"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CardTitle = _interopRequireDefault(require("./CardTitle.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var CardTitle = function CardTitle(_ref) {
  var title = _ref.title,
    titleProps = _ref.titleProps,
    delimiterProps = _ref.delimiterProps,
    withSubtitle = _ref.withSubtitle,
    tooltipProps = _ref.tooltipProps;
  return /*#__PURE__*/_react["default"].createElement(_CardTitle["default"], _extends({
    id: titleProps.id,
    titleProps: titleProps,
    delimiterProps: delimiterProps,
    withSubtitle: withSubtitle
  }, tooltipProps), title);
};
CardTitle.defaultProps = {
  titleProps: {
    id: '',
    titleFontSize: '',
    isBold: true,
    isUppercase: false,
    textTransform: 'capitalize'
  },
  delimiterProps: {
    titleDelimiter: false,
    position: 'left',
    topMargin: '',
    type: 'small'
  },
  withSubtitle: false,
  tooltipProps: {}
};
CardTitle.propTypes = {
  /** A text to be displayed as the card title */
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  /** Attributes for the card title */
  titleProps: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    titleFontSize: _propTypes["default"].string,
    isBold: _propTypes["default"].bool,
    isUppercase: _propTypes["default"].bool,
    textTransform: _propTypes["default"].oneOf(['none', 'capitalize', 'uppercase', 'lowercase'])
  }),
  /** Attributes for the delimiter */
  delimiterProps: _propTypes["default"].shape({
    titleDelimiter: _propTypes["default"].bool,
    position: _propTypes["default"].string,
    topMargin: _propTypes["default"].string,
    type: _propTypes["default"].oneOf(['small', 'medium'])
  }),
  withSubtitle: _propTypes["default"].bool,
  tooltipProps: _propTypes["default"].shape({})
};
CardTitle.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CardTitle",
  "props": {
    "titleProps": {
      "defaultValue": {
        "value": "{\r\n  id: '',\r\n  titleFontSize: '',\r\n  isBold: true,\r\n  isUppercase: false,\r\n  textTransform: 'capitalize',\r\n}",
        "computed": false
      },
      "description": "Attributes for the card title",
      "type": {
        "name": "shape",
        "value": {
          "id": {
            "name": "string",
            "required": false
          },
          "titleFontSize": {
            "name": "string",
            "required": false
          },
          "isBold": {
            "name": "bool",
            "required": false
          },
          "isUppercase": {
            "name": "bool",
            "required": false
          },
          "textTransform": {
            "name": "enum",
            "value": [{
              "value": "'none'",
              "computed": false
            }, {
              "value": "'capitalize'",
              "computed": false
            }, {
              "value": "'uppercase'",
              "computed": false
            }, {
              "value": "'lowercase'",
              "computed": false
            }],
            "required": false
          }
        }
      },
      "required": false
    },
    "delimiterProps": {
      "defaultValue": {
        "value": "{\r\n  titleDelimiter: false,\r\n  position: 'left',\r\n  topMargin: '',\r\n  type: 'small',\r\n}",
        "computed": false
      },
      "description": "Attributes for the delimiter",
      "type": {
        "name": "shape",
        "value": {
          "titleDelimiter": {
            "name": "bool",
            "required": false
          },
          "position": {
            "name": "string",
            "required": false
          },
          "topMargin": {
            "name": "string",
            "required": false
          },
          "type": {
            "name": "enum",
            "value": [{
              "value": "'small'",
              "computed": false
            }, {
              "value": "'medium'",
              "computed": false
            }],
            "required": false
          }
        }
      },
      "required": false
    },
    "withSubtitle": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "tooltipProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "title": {
      "description": "A text to be displayed as the card title",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "node"
        }]
      },
      "required": true
    }
  }
};
var _default = /*#__PURE__*/(0, _react.memo)(CardTitle);
exports["default"] = _default;